export default __webpack_public_path__ + "static/media/BusStop.41b01ae6.jpeg";